import useTypedSelector from 'common/hooks/useTypedSelector';
import { useLocation } from 'react-router';
import ProfilePresenter from './ProfilePresenter';

function ProfileContainer() {
  const profile = useTypedSelector((state) => state.profile);
  const { hash } = useLocation();

  return (
    <>
      <ProfilePresenter
        profile={{
          first: profile.data.firstName,
          last: profile.data.lastName,
          mobile: profile.data.mobileNum,
        }}
        pathHash={hash}
      />
    </>
  );
}

export default ProfileContainer;
